import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { get_product_ai_users, newDataUpload_productAi } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';

function MauiDashboard() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showVPMenu, setShowVPMenu] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState<string | null>(null);
  const [customersData, setCustomersData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
  const vpRef = useRef<HTMLDivElement | null>(null);
  const itemsPerPage = 10;

  const [newData, setNewData] = useState({
    username: "",
    email: "",
    userInfo: "",
    product: "",
    expectedV1: "",
    expectedV2: "",
    expectedV3: "",
    file: null as File | null,
    salesPerson: "",
    prospect: ""
  });

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setNewData({ ...newData, [name]: value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setNewData({ ...newData, file });
  };

  const handleFormSubmit = async () => {
    setLoading(true)
    if (!newData.username || !newData.email || !newData.product || !newData.file || !newData.salesPerson || !newData.prospect || !newData.expectedV1 || !newData.expectedV2 || !newData.expectedV3) {
      alert("Please fill all fields and upload a file.");
      return;
    }

    const formData = new FormData();
    formData.append("username", newData.username);
    formData.append("email", newData.email);
    formData.append("userInfo", newData.userInfo);
    formData.append("product", newData.product);
    formData.append("expectedV1", newData.expectedV1);
    formData.append("expectedV2", newData.expectedV2);
    formData.append("expectedV3", newData.expectedV3);
    formData.append("file", newData.file);
    formData.append("salesPerson", newData.salesPerson);
    formData.append("prospect", newData.prospect);
    formData.append("user_chat_id", current_user_chat_code)

    try {
      await newDataUpload_productAi(formData);
      setShowModal(false);
      setNewData({ username: "", email: "", userInfo: "", product: "",expectedV1: "",expectedV2: "",expectedV3: "", file: null, salesPerson: "", prospect: "" });
      await getAll(); 
      alert("Upload sucessfull");
    } catch (error) {
      console.error("Upload failed", error);
      alert("Upload failed.");
    }
    finally{
        setLoading(false)
        window.location.reload();
    }
  };

  const filteredCustomers = customersData.filter(
    (customer: any) =>
      customer.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  const paginatedCustomers = filteredCustomers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleRowClick = (email: string,name: string) => {
    navigate(`/MauiPrePostCall/?email=${email}&name=${name}`);
  };

  async function getAll() {
    const response = await get_product_ai_users();
    if(response.status != "No users found"){
        setCustomersData(response);
    }
  }

  useEffect(() => {
    getAll();
    const CC = uuidv4() 
    setCurrent_user_chat_code(CC);

    const handleClickOutside = (event: MouseEvent) => {
      if (vpRef.current && !vpRef.current.contains(event.target as Node)) {
        setShowVPMenu(false);
        setSelectedTopic(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative p-6 min-h-screen bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 w-full">
      <div className="absolute top-4 right-6 z-50">
        {/* <button
          onClick={() => setShowVPMenu(!showVPMenu)}
          className="bg-indigo-500 text-white px-3 py-1 rounded-full shadow-md hover:bg-indigo-600 transition"
        >
          VP
        </button> */}

        {showVPMenu && (
          <div
            ref={vpRef}
            className="mt-2 fixed right-1 bg-white border border-purple-300 shadow-lg rounded-xl w-[17%] z-50"
          >
            {["Maui"].map((item) => (
              <div
                key={item}
                onClick={() =>
                  setSelectedTopic((prev) => (prev === item ? null : item))
                }
                className="cursor-pointer px-4 py-2 hover:bg-purple-100 text-indigo-800 font-semibold border-b last:border-b-0"
              >
                {item}

                {selectedTopic === item && (
                  <div className="mt-2 bg-purple-50 border border-purple-300 rounded-lg p-3 text-sm text-purple-900 shadow-xl">
                    <p className="mb-2 font-bold">{item} Key Points:</p>
                    <ul className="list-disc list-inside space-y-1">
                      <li>Systemic way to find direction</li>
                      <li>Find Repeating Persona</li>
                      <li>Find value prop to go deep</li>
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <h1 className="text-4xl font-extrabold mb-6 text-indigo-800 font-[Open_Sans]">
        Moana Dashboard
      </h1>

      <div className="mb-4 flex items-center gap-4">
        <input
          type="text"
          placeholder="🔍 Search by username or email..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="p-3 border border-purple-300 rounded-lg w-full max-w-lg focus:ring-2 focus:ring-purple-500"
        />

        <button
          onClick={() => setShowModal(true)}
          className="bg-green-600 hover:bg-green-600 text-white px-4 py-2 rounded-lg shadow-md transition"
        >
          + New Data
        </button>
      </div>

      <div className="bg-white/90 backdrop-blur-md shadow-xl rounded-2xl overflow-hidden border border-purple-200">
        <table className="min-w-full text-sm text-left text-gray-800">
          <thead className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white text-xs uppercase">
            <tr>
              <th className="px-6 py-3">Username</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">Info</th>
            </tr>
          </thead>
          <tbody>
            {paginatedCustomers.length !== 0 ? paginatedCustomers.map((customer: any) => (
              <tr
                key={customer.id}
                onClick={() => handleRowClick(customer.email,customer.username)}
                className="cursor-pointer hover:bg-indigo-100 transition duration-200"
              >
                <td className="px-6 py-4 font-semibold text-indigo-700">
                  {customer.username}
                </td>
                <td className="px-6 py-4">{customer.email}</td>
                <td className="px-6 py-4 text-gray-600">{customer.info}</td>
              </tr>
            )) : <tr><td colSpan={6} className="text-center"><p className="font-bold mt-3 mb-3 text-xl">--- No Data ---</p></td></tr>}
          </tbody>
        </table>
      </div>

      <div className="flex justify-between items-center mt-6">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          className="px-4 py-2 bg-purple-400 text-white rounded-lg shadow-md hover:bg-purple-500 disabled:opacity-40"
        >
          ⬅ Previous
        </button>

        <span className="text-sm text-gray-700 font-medium">
          Page <span className="text-purple-700">{currentPage}</span> of{" "}
          <span className="text-purple-700">{totalPages}</span>
        </span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
          className="px-4 py-2 bg-purple-400 text-white rounded-lg shadow-md hover:bg-purple-500 disabled:opacity-40"
        >
          Next ➡
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-40">
          <div className="bg-white p-6 rounded-2xl w-[90%] max-w-md shadow-lg border border-purple-300">
            <h2 className="text-xl font-bold mb-4 text-purple-700">
              Upload New Data
            </h2>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Username</label>
              <input
                type="text"
                name="username"
                value={newData.username}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Email</label>
              <input
                type="email"
                name="email"
                value={newData.email}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">User Info</label>
              <input
                type="userInfo"
                name="userInfo"
                value={newData.userInfo}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Product</label>
              <select
                name="product"
                value={newData.product}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              >
                <option value="">Select a product</option>
                <option value="Moana">Moana</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Expected VP1</label>
              <select
                name="expectedV1"
                value={newData.expectedV1}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              >
                <option value="">Select a Category</option>
                <option value="Cannot live without it">Cannot live without it</option>
                <option value="Nice to have">Nice to have</option>
                <option value="Not my problem">Not my problem</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Expected VP2</label>
              <select
                name="expectedV2"
                value={newData.expectedV2}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              >
                <option value="">Select a Category</option>
                <option value="Cannot live without it">Cannot live without it</option>
                <option value="Nice to have">Nice to have</option>
                <option value="Not my problem">Not my problem</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Expected VP3</label>
              <select
                name="expectedV3"
                value={newData.expectedV3}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              >
                <option value="">Select a Category</option>
                <option value="Cannot live without it">Cannot live without it</option>
                <option value="Nice to have">Nice to have</option>
                <option value="Not my problem">Not my problem</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Upload File</label>
              <input
                type="file"
                onChange={handleFileChange}
                className="w-full"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Sales Person</label>
              <input
                type="text"
                name="salesPerson"
                value={newData.salesPerson}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1 text-sm font-medium">Prospect</label>
              <input
                type="text"
                name="prospect"
                value={newData.prospect}
                onChange={handleFormChange}
                className="w-full border border-gray-300 p-2 rounded"
              />
            </div>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmit}
                className="px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
        {loading && (
          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="flex flex-col items-center gap-4 p-6 rounded-2xl bg-gradient-to-br from-purple-100 via-white to-indigo-100 shadow-xl border border-purple-300">
              <svg
                className="animate-spin h-10 w-10 text-purple-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              <p className="text-lg font-semibold text-purple-700 animate-pulse">
                Uploading... Please wait
              </p>
            </div>
          </div>
        )}
    </div>
  );
}

export default MauiDashboard;
